var _path, _path2, _path3, _path4;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSalvaPdf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0013 33.8333H24.0013C30.668 33.8333 33.3346 31.1667 33.3346 24.5V16.5C33.3346 9.83332 30.668 7.16666 24.0013 7.16666H16.0013C9.33464 7.16666 6.66797 9.83332 6.66797 16.5V24.5C6.66797 31.1667 9.33464 33.8333 16.0013 33.8333Z",
    stroke: "#A3A1AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16 19.8466L20 23.8466L24 19.8466",
    stroke: "#A3A1AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M20 23.8467V13.18",
    stroke: "#A3A1AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12 26.5133C17.1867 28.2467 22.8133 28.2467 28 26.5133",
    stroke: "#A3A1AA",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalvaPdf);
export default __webpack_public_path__ + "static/media/salvaPdf.bcfc3ff1.svg";
export { ForwardRef as ReactComponent };